import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../../components/ui/Button';

const BusinessHeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToPipeline = () => {
    document.getElementById('pipeline')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative isolate overflow-hidden bg-white pt-28 pb-16 sm:pt-32 lg:pb-24 lg:pt-36">
      <div className="lp-grain absolute inset-0 -z-10" />
      <div className="absolute -left-32 top-20 h-[420px] w-[420px] rounded-full bg-[var(--lp-accent)]/8 blur-[100px]" />
      <div className="absolute right-0 top-1/3 h-[300px] w-[300px] rounded-full bg-[var(--lp-accent)]/10 blur-[80px] dark:opacity-40" />

      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="text-center max-w-5xl mx-auto"
        >
          {/* <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[var(--lp-line)] bg-white px-4 py-1.5 text-xs text-[var(--lp-ink-soft)]">
            <span className="flex h-2 w-2 rounded-full bg-emerald-500 animate-pulse" />
            Interview 500 candidates, not 50
          </div> */}

          <h1 className="text-[2.75rem] leading-[1.05] tracking-tight text-[var(--lp-ink)] sm:text-6xl lg:text-[4rem]">
            Automate your hiring pipeline <br className="hidden sm:block" />
            <span className="block text-[var(--lp-accent)]">with prepxai</span>
          </h1>

          <p className="mt-6 max-w-2xl mx-auto text-lg leading-relaxed text-[var(--lp-ink-soft)] lg:text-[1.2rem]">
            Build automated hiring pipelines with custom scoring at every stage. Upload resumes, run AI interviews at scale, and let prepxai learn from your hiring decisions.
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-center">
            <Button
              size="lg"
              onClick={scrollToContact}
              className="h-12 rounded-full bg-[var(--lp-accent)] px-8 text-sm text-white hover:bg-[var(--lp-accent)]/90"
              iconName="Building2"
              iconPosition="right"
            >
              Book a Demo
            </Button>
            <button
              type="button"
              onClick={scrollToPipeline}
              className="inline-flex h-12 items-center justify-center gap-2 rounded-full border border-[var(--lp-line)] bg-transparent px-6 text-sm text-[var(--lp-ink)] transition-colors hover:bg-white"
            >
              See the pipeline
            </button>
          </div>

          <div className="mt-12 flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-[var(--lp-ink-soft)] text-sm">
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Multi-stage pipelines
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Custom scoring filters
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Resume bulk upload
            </span>
            <span className="flex items-center gap-2">
              <span className="text-emerald-500">✓</span> Learns from your hires
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BusinessHeroSection;
